module.exports = __webpack_public_path__ + "img/logout.79bf30e1.svg";